import React from 'react'
import { Spin, Typography, Space } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './Loading.less';

export default function LoadingFullScreen(props) {

    const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

    return (
        <div className="loading-fullscreen">
            <Space size="large" direction="vertical" align="center">
                <Spin indicator={antIcon} />
                <Typography className="loading-fullscreen-text">{props.text}</Typography>
            </Space>
        </div>
    )
}